
<div class="row">
  <div class="col-2 offset-5">
    <div class="card">
      <article class="card-body">
        <h4 class="card-title text-center mb-4 mt-1">Sign in</h4>
        <hr>
        <form [formGroup]="loginForm"  (ngSubmit)="onSubmit()">
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text"> <i class="fa fa-user"></i> </span>
              </div>
              <input formControlName="login" class="form-control" placeholder="Login" type="text" >
            </div>
          </div>
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text"> <i class="fa fa-lock"></i> </span>
              </div>
              <input formControlName="password" class="form-control" placeholder="******" type="password" value="admin">
            </div>
          </div>
          <div class="form-group">
            <button [disabled]="!loginForm.valid" type="submit" class="btn btn-primary btn-block"> Login  </button>
          </div>
        </form>
      </article>
    </div>
  </div>
</div>
